import React, { useEffect, useState } from "react";
// import ReactPlayer from "react-player";
import { X } from "react-feather";
import captureVideoFrame from "./capture-video-frame.js";

import { CircularProgress, Modal } from "@material-ui/core";
import CanvasFrame from "../CanvasFrame/CanvasFrame.component";
import PlayerErrorCard from "../Utilities/PlayerErrorCard/PlayerErrorCard";
import { checkAudio } from "../utils.js";
import CustomSeekBar from "./CustomSeekBar.jsx";
import useStyles from "./player.styles";

function Player({
  seekTime,
  player,
  setScreenshot,
  canvasModal,
  comments,
  playing,
  users,
  setList,
  screenshot,
  assetId,
  fetchComments,
  version_id,
  updatesPage,
  data,
  setPlayerProgress,
  handlePlayPause,
  seekForward,
  seekBack,
  scrollToComment,
  updateRefresh,
  selectedVersion,
  playerContainer,
  handleFullScreen,
  isFullScreen,
  handleSeekKeyboardEvent,
  forExternalReviewer,
  playNextVersion,
}) {
  const [canvasmodal, setCanvasModal] = useState(false);
  const [progress, setProgress] = useState("00:00");
  const canvasModalToggle = () => setCanvasModal(!canvasmodal);
  const classes = useStyles();

  //custom seekbar states
  const [totalDuration, setTotalDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0); //current time of video
  const [currentTimeSeek, setCurrentTimeSeek] = useState(0); //changes when seek via custom seek bar
  const [annotations, setAnnotations] = useState([]);
  const [initaial, setInitaial] = useState(false); // represent first onchange of a video
  const [arrAnnotation, setArrAnnotation] = useState([]); //array of card to be displayed
  const [currentMark, setCurrentMark] = useState(null); //represent the current hovered over mark
  const [showControls, setShowControls] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    code: 2,
    message: "An error occurred, Please try again later!",
  });
  const [volumePlayer, setVolumePlayer] = useState({
    volume: 20,
    muted: false,
  });

  useEffect(() => {
    if (seekTime) {
      player.current.currentTime = seekTime;
    }
  }, [seekTime]);

  useEffect(() => {
    if (currentTimeSeek) {
      player.current.currentTime = currentTimeSeek;
    }
  }, [currentTimeSeek]);
  useEffect(() => {
    const frame = captureVideoFrame(player?.current);
    setScreenshot(frame.dataUri);
  }, [canvasModal]);

  useEffect(() => {
    generateAnnotations();
  }, [comments, totalDuration]);
  // custom seekbar functions

  //this function get eliminates the old comments for same node and only keeps the latest one
  function getLatestComments(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }
  // generates annotations out of comments
  function generateAnnotations() {
    let ArrayAnotation = [];
    let displayAnnotaionarr = [];
    if (comments?.length) {
      for (let i = 0; i < comments.length; i++) {
        let stamp = [];
        if (forExternalReviewer) {
          stamp = comments[i]?.text?.split("<p>");
        } else {
          stamp = comments[i]?.description?.split("<p>");
        }
        let stampInt;
        if (stamp?.length && stamp[0] !== "") {
          if (stamp[0]?.includes(":")) {
            stamp[0]?.split(":").map((eachInt, index) => {
              if (index === 0) {
                stampInt = parseInt(eachInt) * 60;
              } else {
                stampInt = stampInt + parseInt(eachInt);
              }
            });
          } else {
            stampInt = Math.round(stamp[0]);
          }
        }
        if (parseInt(stampInt) === 0) {
          ArrayAnotation.push({ value: 0 });
        }
        if (parseInt(stampInt)) {
          ArrayAnotation.push({
            value: parseInt((parseInt(stampInt) / totalDuration) * 100), //get stamp for 100% of seek bar
            label: "",
          });
          displayAnnotaionarr.push({
            value: parseInt((parseInt(stampInt) / totalDuration) * 100),
            label: comments[i],
          });
          //array gets the stamp and detail of each stamp for card
        }
      }
    }
    const arr1 = getLatestComments(displayAnnotaionarr, "value");
    setAnnotations(ArrayAnotation);
    setArrAnnotation(arr1);
  }

  useEffect(() => {
    if (playing) {
      player?.current?.play();
    } else {
      player?.current?.pause();
    }
  }, [playing]);

  useEffect(() => {
    if (player?.current) {
      player.current.volume = volumePlayer.volume / 100;
      player.current.muted = volumePlayer.muted;
    }
  }, [volumePlayer]);

  const reLoad = () => {
    updateRefresh();
  };

  useEffect(() => {
    setShowError(false);
  }, [selectedVersion]);

  useEffect(() => {
    if (isFullScreen) {
      playerContainer.current.focus();
    }
  }, [isFullScreen]);

  return (
    <div style={{ height: "100%" }}>
      <Modal open={canvasmodal} className={classes.modal}>
        <div className={classes.canvasDiv}>
          <CanvasFrame
            users={users}
            setCommentList={setList}
            isUpdate={setList ? true : false}
            image={screenshot}
            assetId={assetId}
            toggle={canvasModalToggle}
            fetchComments={fetchComments}
            version_id={version_id}
            progress={progress}
          />
        </div>
      </Modal>

      {!showError ? (
        <div
          style={{
            height: "100%",
            position: "relative",
            backgroundColor: checkAudio(data) ? "transparent" : "black",
            outline: "none",
            backgroundImage: checkAudio(data)
              ? "url(https://i.ibb.co/y0Dncfq/image-2024-05-09-16-44-18.png)"
              : "",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          ref={playerContainer}
          tabIndex={0}
          onKeyDown={handleSeekKeyboardEvent}
        >
          {showControls ? (
            ""
          ) : updatesPage ? (
            ""
          ) : (
            <div className={classes.loader}>
              <CircularProgress />
              <div>Buffering...</div>
            </div>
          )}
          <video
            style={{
              height: "100%",
              width: "100%",
              filter: showControls ? "" : "blur(5px)",
              backgroundColor: "transparent",
            }}
            src={data ? data : ""}
            crossOrigin="anonymous"
            ref={player}
            onLoadedData={() => {
              setShowControls(true);
              setTotalDuration(player?.current.duration);
            }}
            onError={(error) => {
              console.log("error", error);
              if (error.target.error.code === 4) {
                setErrorMessage({
                  code: 4,
                  message: "Media source not supported",
                });
              }
              setShowError(true);
            }}
            onPlaying={() => setShowControls(true)}
            onWaiting={() => {
              if (!playing) {
                setShowControls(false);
              }
            }}
            onEnded={() => {
              handlePlayPause();
              if (playNextVersion) {
                playNextVersion();
              }
            }}
            controls={updatesPage ? true : false}
            onContextMenu={(e) => e.preventDefault()}
            onTimeUpdate={(e) => {
              setCurrentTime(player?.current.currentTime);
              let seconds = 0;
              let minutes = 0;
              if (player?.current.currentTime % 60) {
                minutes = parseInt(player?.current.currentTime / 60);
                seconds = parseInt(player?.current.currentTime % 60);
                if (seconds < 10) {
                  seconds = `0${seconds}`;
                }
              }
              let time = `${minutes}:${seconds}`;
              setProgress(time);
              setPlayerProgress(player?.current.currentTime);
              setInitaial(true);
            }}
          />
          {/* div that floats on video player */}
          {updatesPage ? (
            ""
          ) : (
            <div
              style={{
                zIndex: "10",
                width: "100%",
                position: "absolute",
                marginTop: "-50px",
              }}
            >
              <CustomSeekBar
                isPlaying={playing}
                handlePlayPause={handlePlayPause}
                onTimeSeek={(time) => setCurrentTimeSeek(time)}
                currentTime={currentTime}
                totalDuration={totalDuration}
                annotations={annotations}
                seekForward={seekForward}
                seekBack={seekBack}
                onDownload={() => (window.location.href = data)}
                arrAnnotation={arrAnnotation}
                currentMark={currentMark}
                setCurrentMark={setCurrentMark}
                scrollToComment={scrollToComment}
                progress={progress}
                volume={volumePlayer.volume}
                onVolumeChange={(volume) =>
                  setVolumePlayer({ ...volumePlayer, volume: volume })
                }
                muted={volumePlayer.muted}
                onMute={(muted) => {
                  setVolumePlayer({ ...volumePlayer, muted: muted });
                }}
                handleFullScreen={handleFullScreen}
                isFullScreen={isFullScreen}
                forExternalReviewer={forExternalReviewer}
              />
            </div>
          )}
        </div>
      ) : (
        <PlayerErrorCard
          errorMessage={errorMessage}
          reLoad={reLoad}
          file={data}
        />
      )}
    </div>
  );
}

export default Player;
